// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3ebfk","colMaxWidth":"Table_colMaxWidth__2_wE2"};